import { render, staticRenderFns } from "./ModalRecommendation.vue?vue&type=template&id=6628f96b&scoped=true"
import script from "./ModalRecommendation.vue?vue&type=script&lang=js"
export * from "./ModalRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ModalRecommendation.vue?vue&type=style&index=0&id=6628f96b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6628f96b",
  null
  
)

export default component.exports